<template>
  <v-container class="pa-0">
    <v-form ref="form">
      <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
        <page-header-title :title="page_title"></page-header-title>
        <p v-if="course.id && course.status == 0" class="ml-4 mb-0 headline text-uppercase font-weight-regular">
          {{ $dd_course_status(course.status) }}
        </p>

        <v-spacer></v-spacer>

        <router-link :to="'/f/' + locale + '/course/upcoming'" class="" target="_blank" v-if="course.id && course.status == 0">
          <action-button type="new" :text="$t('courses.upcoming_course')" :icon="'book'" />
        </router-link>
      </v-app-bar>

      <v-container grid-list-md>
        <v-card>
          <v-card-text class="pa-4">
            <v-layout row wrap>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  :value="course.coursetypegroup ? course.coursetypegroup.fullname : ''"
                  :label="$t('coursetypegroups.title')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  :value="course.coursetype ? course.coursetype.fullname : ''"
                  :label="$t('coursetypes.title')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field :value="course.name" :label="$t('courses.name')" readonly autocomplete="new-password"></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  :value="course.instructor ? course.instructor.fullname : ''"
                  :label="$t('courses.instructor_id')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  :value="course.address ? course.address.full_address : ''"
                  :label="$t('addresses.stitle')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  :value="course.classroom ? course.classroom.name : ''"
                  :label="$t('classrooms.title')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>

        <v-expansion-panels v-model="clpsCourseDateExpand" class="cstm-filter mt-4 elevation-0" ref="attendees_expansion_panels">
          <v-expansion-panel>
            <v-expansion-panel-header hide-actions>
              <span>
                <v-icon dark>{{ clpsCourseDateIcon }}</v-icon>
                {{ $t("courses.course_dates") }}
              </span>
              <v-spacer></v-spacer>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="elevation-1">
              <v-layout row wrap>
                <v-flex lg2 md3 sm6 xs8>
                  <v-text-field
                    :value="computedCourseStartDate"
                    :label="$t('courses.start_date')"
                    readonly
                    autocomplete="new-password"
                  ></v-text-field>
                </v-flex>
                <v-flex lg2 md3 sm6 xs4>
                  <v-text-field
                    :value="computedCourseStartTime"
                    :label="$t('courses.start_time')"
                    readonly
                    autocomplete="new-password"
                  ></v-text-field>
                </v-flex>
                <v-flex lg2 md3 sm6 xs8>
                  <v-text-field
                    :value="computedCourseEndDate"
                    :label="$t('courses.end_date')"
                    readonly
                    autocomplete="new-password"
                  ></v-text-field>
                </v-flex>
                <v-flex lg2 md3 sm6 xs4>
                  <v-text-field
                    :value="computedCourseEndTime"
                    :label="$t('courses.end_time')"
                    readonly
                    autocomplete="new-password"
                  ></v-text-field>
                </v-flex>
                <v-flex lg2 md3 sm6 xs6>
                  <v-text-field
                    :value="course.num_places"
                    :label="$t('courses.num_places')"
                    readonly
                    autocomplete="new-password"
                  ></v-text-field>
                </v-flex>
                <!-- COURSE START/END TIME -->
                <v-flex xs12 md6 lg4>
                  <v-layout row wrap>
                    <v-flex xs12 v-for="(cet, index) in course_times" :key="index">
                      <v-layout row wrap>
                        <v-flex xs6>
                          <v-text-field
                            v-model="cet.date_format"
                            :label="$t('drivingtests.date')"
                            append-icon="event"
                            readonly
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs6 sm3>
                          <v-text-field
                            v-model="cet.start_time"
                            :label="$t('courses.start_time')"
                            append-icon="schedule"
                            readonly
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs6 sm3>
                          <v-text-field
                            v-model="cet.end_time"
                            :label="$t('courses.end_time')"
                            append-icon="schedule"
                            readonly
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <v-expansion-panels v-model="clpsCourseDescExpand" class="cstm-filter mt-4 elevation-0" ref="attendees_expansion_panels">
          <v-expansion-panel>
            <v-expansion-panel-header hide-actions>
              <span>
                <v-icon dark>{{ clpsCourseDescIcon }}</v-icon>
                {{ $t("courses.course_descriptions") }}
              </span>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="elevation-1">
              <v-layout row wrap>
                <v-flex xs12>
                  <v-textarea
                    :value="course.short_description"
                    rows="1"
                    auto-grow
                    :label="$t('courses.short_description')"
                    readonly
                  ></v-textarea>
                </v-flex>
                <v-flex xs12>
                  <v-textarea :value="course.description" rows="3" auto-grow readonly :label="$t('courses.description')"></v-textarea>
                </v-flex>
              </v-layout>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-container>
    </v-form>
  </v-container>
</template>

<script>
export default {
  name: "CourseView",

  props: ["id", "locale", "uuid"],

  data() {
    return {
      page_title: "",

      course: {},
      coursetemplate: {},
      course_times: [],
      moduletemplates: [],

      clpsCourseDateIcon: "mdi-collapse-all-outline",
      clpsCourseDateExpand: 0,

      clpsCourseDescIcon: "mdi-expand-all-outline",
      clpsCourseDescExpand: undefined,

      clpsModuleTemplateIcon: "mdi-expand-all-outline",
      clpsModuleTemplateExpand: undefined
    }
  },

  computed: {
    computedCourseStartDate: {
      get() {
        return this.$dateFormatGetter(this.course.start_date)
      },
      set(val) {
        this.$set(this.course, "start_date", this.$dateFormatSetter(val))
      }
    },
    computedCourseStartTime: {
      get() {
        return this.$timeFormatGetter(this.course.start_time)
      },
      set(val) {
        this.$set(this.course, "start_time", this.$timeFormatSetter(val))
      }
    },
    computedCourseEndDate: {
      get() {
        return this.$dateFormatGetter(this.course.end_date)
      },
      set(val) {
        this.$set(this.course, "end_date", this.$dateFormatSetter(val))
      }
    },
    computedCourseEndTime: {
      get() {
        return this.$timeFormatGetter(this.course.end_time)
      },
      set(val) {
        this.$set(this.course, "end_time", this.$timeFormatSetter(val))
      }
    }
  },

  watch: {
    clpsCourseDateExpand: {
      handler(newVal, oldVal) {
        this.clpsCourseDateIcon = newVal === undefined ? "mdi-expand-all-outline" : "mdi-collapse-all-outline"
      }
    },
    clpsCourseDescExpand: {
      handler(newVal, oldVal) {
        this.clpsCourseDescIcon = newVal === undefined ? "mdi-expand-all-outline" : "mdi-collapse-all-outline"
      }
    },
    clpsAttendeeExpand: {
      handler(newVal, oldVal) {
        this.clpsAttendeeIcon = newVal === undefined ? "mdi-expand-all-outline" : "mdi-collapse-all-outline"
      }
    },
    clpsEnrolmentExpand: {
      handler(newVal, oldVal) {
        this.clpsEnrolmentIcon = newVal === undefined ? "mdi-expand-all-outline" : "mdi-collapse-all-outline"
      }
    },
    clpsModuleTemplateExpand: {
      handler(newVal, oldVal) {
        this.clpsModuleTemplateIcon = newVal === undefined ? "mdi-expand-all-outline" : "mdi-collapse-all-outline"
      }
    }
  },

  created() {
    this.$updateSetting("fe_locale", this.locale)
    this.$i18n.locale = this.locale

    axios
      .get(this.API_URL + "open/course/" + this.id + "/" + this.uuid)
      .then((res) => {
        this.course = res.data.data
        this.moduletemplates = res.data.data.moduletemplates
        this.coursetemplate = this.course.coursetemplate
        this.number_of_days = this.course.number_of_days > 0 ? this.course.number_of_days : 1
        this.currentCourseTypes = this.course.coursetemplate.coursetypes ? this.course.coursetemplate.coursetypes.map((a) => a.id) : []

        this.course_times = []
        if (this.course.start_date && this.course.start_time && this.course.end_date && this.course.end_time) {
          let time_per_day = this.course.time_per_day
          let start = this.moment(this.course.start_date, this.MYSQL_DATE_FORMAT)
          let end = this.moment(this.course.end_date, this.MYSQL_DATE_FORMAT)
          let number_of_days = end.diff(start, "days") + 1

          if (number_of_days > 0) {
            if (this.course.adjust_time_per_day && time_per_day) {
              for (const [index, row] of Object.entries(time_per_day)) {
                this.course_times.push({
                  index: index,
                  date: row.date,
                  date_format: this.$dateFormatGetter(row.date),
                  start_time: row.start_time,
                  end_time: row.end_time
                })
              }
            }
          }
        }

        this.setPageTitle()
      })
      .catch((err) => console.log(err))
  },

  methods: {
    setPageTitle() {
      this.page_title = this.$t("courses.view_course", {
        name: this.course.name
      })
    }
  }
}
</script>
